<template>
  <div
    class="p4-report"
  >
    <div class="topBar">
      <span 
        v-if="isAuthenticated"
        class="menuButton icon-menu-24"  
        dark
        @click.stop="drawer = !drawer"
      />
      <span class="clientName">{{ title }}</span>
      <v-spacer />
      <router-link to="/admin/logout">
        <button
          class="logout"
        >
          LOG OUT
        </button>
      </router-link>
    </div>

    <Menu
      color="adminPrimary"
      :is-open="drawer"
    />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Menu from "../components/Menu";
import canvas_bg from "../assets/canvas_bg.png";
import parseJwt from "../helperFunctions/ParseJWT";
import store from "../store/store";

const bodyHeight =
  document.getElementById("NavBar") != null
      ? window.innerHeight - document.getElementById("NavBar").offsetHeight
      : window.innerHeight;

let isRefreshingToken = false;

function  RefreshToken() {
    isRefreshingToken = true;
    return store
        .dispatch("refreshAccessToken");               
}
 
export default {
    components: {
        Menu: Menu,
    },
    data() {
        return {
            Home: null,
            title: localConfig.psClientName,
            drawer: null,
            parallaxHeight: bodyHeight,
            canvas_background: canvas_bg,
            isPsAlertVisible: false,
            psAlertType: "info",
            psAlertMessage: "",
            background: canvas_bg,
        };
    },
    computed: mapGetters(["isAuthenticated"]),
    beforeRouteEnter(to, from, next) {
        if (to.params.token && !window.token) {
            localStorage.setItem("token", to.params.token);
            localStorage.setItem("refresh_token", to.params.rt);

            window.token = to.params.token;
            window.user = to.params.rt;
            RefreshToken().then(({ status }) => {
                if (status === 200 || status === 204) {
                    isRefreshingToken = false;
                    $("body").css("background", "white");
                    next();
                }
            })
                .catch((error) => {
                    isRefreshingToken = false;
                    console.error(error.message);
                    store.dispatch("adminLogin");
                });
        }
        else {
            next();     
        }
    },
    created() {
        if (this.isTokenValid()) {
        } else {
            RefreshToken(); // if this fails user is redirected to login screen
        }

        window.Bus.$on("psAlert", (alertPkg) => {
            this.PsAlertMessage = alertPkg.msg;
            this.psAlertType = alertPkg.type;
            this.isPsAlertVisible = true;
        });

        axios.interceptors.response.use(undefined, function (err) {
            return new Promise(function (resolve, reject) {
                if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                    this.$store.dispatch("logout");
                }
                throw err;
            });
        });
    },
    methods: {       
        isTokenValid() {
            if (isRefreshingToken) return true;

            try {
                var exp = parseJwt(window.token).exp;

                var exptime = new Date();
                exptime.setMinutes(exptime.getMinutes() + 10);

                var tokenExpTime = new Date(exp * 1000);

                console.log("token will expire at " + tokenExpTime);

                if (exptime >= tokenExpTime) {
                    //If withing 10 minutes of expiring, refresh
                    this.RefreshToken();
                }

                return true;
            } catch {
                this.$store.dispatch("adminLogin");
            }
        }
    },   
};
</script>

<style lang="scss" scoped>
@import "../styles/p3.scss";
@import "../styles/admin.scss";
</style>
